import ScoreNumberOnly from '@/presentation/components/common/scoreTypes/ScoreNumberOnly/ScoreNumberOnly.vue';
import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { WidgetTypes } from 'interfaces';
import MainDeterminant from './MainDeterminant.CB';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';

export default defineComponent({
	components: {
		ScoreNumberOnly,
	},
	props: {
		studyId: Number,
		widgetType: String,
		widgetLocation: String,
		emptyText: String,
		determinantType: Number,
	},
	setup: (props) => {
		const studyId = props.studyId as number;
		const widgetType = props.widgetType as WidgetTypes;
		const widgetLocation = props.widgetLocation as string;
		const emptyText = props.emptyText as string;
		const determinantType = props.determinantType as ScoreDeterminantType;

		const codeBehind = new MainDeterminant(
			studyId,
			widgetType,
			widgetLocation,
			emptyText,
			determinantType,
		);

		return setupComponent(codeBehind);
	},
});
